/* eslint-disable import/prefer-default-export */
import { FacebookAuthProvider } from 'firebase/auth';

export const facebookProvider = new FacebookAuthProvider();
